import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/store/modules/api.js'
const moment = require('moment');


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tab:null,
    trabajadores:[],
    tipos_permisos:[],
    permisos:[],
    festivos:[],
    fichajes:[],
    horasTotales:[],
    filtro_inicio:null,
    filtro_fin:null,
    filtro_trabajador:{}
  },
  getters: {
  },
  mutations: {
    setTrabajadores(state, payload){
      state.trabajadores = payload
    },
    setFichajes(state, payload){
      state.fichajes = payload
    },
    setHorasTotales(state, payload){
      state.horasTotales = payload
    },
    setFestivos(state, payload){
      state.festivos = payload
    },
    setPermisos(state, payload){
      state.permisos = payload
    },
    setTiposPermisos(state, payload){
      state.tipos_permisos = payload
    }
  },
  actions: {
    setTab({commit, state},payload){
      state.tab = payload
    },
    async cargaInicial({dispatch, commit, state}){
      try{
        dispatch('setTrabajadores');
        dispatch('setTiposPermisos');
        dispatch('setFestivos');

        const monday = moment().startOf('isoWeek').format('YYYY-MM-DD')
        const sunday = moment().endOf('isoWeek').format('YYYY-MM-DD')
        
        dispatch('setFiltroFechaInicio', monday)
        dispatch('setFiltroFechaFin', sunday)
        dispatch('setFichajes')
        dispatch('setPermisos')
        dispatch('setHoras', {fecha_inicio: state.filtro_inicio, fecha_fin: state.filtro_fin});
      }catch(e){
        console.log("ERROR EN CARGA INICIAL: ",e);
      }
    },
    async setTrabajadores({dispatch, commit}){
      try{
        const trabajadores_raw = await dispatch('api/getTrabajadores');
        commit('setTrabajadores', trabajadores_raw.data)
      }catch(e){
        console.log("ERROR EN setTrabajadores: ", e.message);
      }
    },
    async setFichajes({dispatch, commit, state}){
      try{
        // let payload = {fecha_inicio: '2024-03-01', fecha_fin: '2024-04-29'}
        let payload = {
          id_trabajador: state.filtro_trabajador.id_trabajador?state.filtro_trabajador.id_trabajador:null, 
          fecha_inicio: state.filtro_inicio,
          fecha_fin: state.filtro_fin
        }
        // let payload = {fecha_inicio: monday, fecha_fin:sunday}
        const fichajes_raw = await dispatch('api/getFichajes', payload);
        commit('setFichajes', fichajes_raw.data)
      }catch(e){
        console.log("ERROR EN setFichajes: ", e.message);

      }
    },
    async setHoras({dispatch, commit, state}, payload){
      try{
        const horas_totales_raw = await dispatch('api/getHorasTrabajadas', payload);
        const horas_permisos_raw = await dispatch('api/getPermisosHoras', payload);
        const horas_totales = horas_totales_raw.data
        const horas_permisos = horas_permisos_raw.data
        state.horasTotales = state.trabajadores.map(t => ({
            id_trabajador: t.id_trabajador,
            nombre_trabajador: t.nombre_trabajador,
            total_minutos:0,
            total_minutos_festivos:0,
            permisos_dias:0,
            permisos_minutos:0
            
        }))
        horas_totales.forEach(element => {
          let trabajador = state.horasTotales.find(e => e.id_trabajador == element.id_trabajador)
          trabajador.total_minutos = element.total_hours
          trabajador.total_minutos_festivos = element.total_hours_festivo
        });
        horas_permisos.forEach(element => {
          let trabajador = state.horasTotales.find(e => e.id_trabajador == element.id_trabajador)
          trabajador.permisos_dias = element.cantidad
          trabajador.permisos_minutos = element.minutos
        });
          
        
      }catch(e){
        console.log("ERROR EN setHoras: ", e.message);

      }
    },
    async setTiposPermisos({dispatch, commit, state}){
      try{

        const permisos_raw = await dispatch('api/getTiposPermisos');
        commit('setTiposPermisos', permisos_raw.data)
      }catch(e){
        console.log("ERROR EN setTiposPermisos: ", e.message);
      }
    },
    async setFestivos({dispatch, commit, state}){
      try{
        const festivos_raw = await dispatch('api/getFestivos');
        commit('setFestivos', festivos_raw.data)
      }catch(e){
        console.log("ERROR EN setFestivos: ", e.message);
      }
    },
    async setPermisos({dispatch, commit, state}){
      try{
        const permisos_raw = await dispatch('api/getPermisos');
        commit('setPermisos', permisos_raw.data)
      }catch(e){
        console.log("ERROR EN setPermisos: ", e.message);
      }
    },
    setFiltroTrabajador({state}, trabajador){
      state.filtro_trabajador = trabajador
    },
    setFiltroFechaInicio({state}, fecha){
      state.filtro_inicio = fecha
    },
    setFiltroFechaFin({state}, fecha){
      state.filtro_fin = fecha
    },
  },
  modules: {
    api
  }
})
